import React from "react";
import Skeleton from "react-loading-skeleton";
import PropTypes from "prop-types";

/**
 * SectionSkeleton — generic loading placeholder shaped like a `<SectionCard>`.
 *
 * A white card with a title bar and a few content lines, for use inside the
 * ProfilePage main-column skeleton while a section's data loads.
 *
 * @param {Object} props
 * @param {number} [props.lines] - Number of body lines to render (default 3)
 */
function SectionSkeleton({ lines = 3 }) {
  return (
    <div
      className="card profile-section-card animated fadeIn faster"
      style={{
        borderRadius: "8px",
        boxShadow: "0px 1px 2px -1px rgba(10, 13, 18, 0.1), 0px 1px 3px 0px rgba(10, 13, 18, 0.1)",
      }}
    >
      <div className="mb-3">
        <Skeleton height={18} width="25%" />
      </div>
      {Array.from({ length: lines }).map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={i} className="mb-2">
          <Skeleton height={14} />
        </div>
      ))}
    </div>
  );
}

SectionSkeleton.propTypes = {
  lines: PropTypes.number,
};

export default SectionSkeleton;
